import * as types from '../constants';
import _ from 'lodash';
import axios from 'axios';
import store from '../';

import {
  updateProfile,
  getUserInfo
} from '../../clientServices/member'

export const getUserInf = body => dispatch => {
  getUserInfo(body)
    .then(res=>{
      dispatch({
          type: types.GET_USER_INF,
          payload: _.get(res, 'user', {})
      })
    })
}

export const setUserInf = body => dispatch => {
  dispatch({
      type: types.GET_USER_INF,
      payload: body
  })
}

export const updateUserProfile = (body, cb) => dispatch => {
  updateProfile(body)
    .then(res=>{
      store.dispatch(getUserInf())
      typeof cb === 'function' && cb()
    })
}
